import React, { Component } from "react";
import TimePicker from "rc-time-picker";
import M from "moment";

class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeState: this.props.time ? M(this.props.time) : null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.time !== prevProps.time) {
      //   console.log(this.props.time)
      this.setState({
        timeState: this.props.time ? M(this.props.time) : null,
      });
    }
  }

  onTimeChange(options) {
    if (options != null) {
      // do something
      let time = M(options)

      // console.log('now', options)

      this.setState({
        timeState: time
      })

      this.props.onChange(time)
    }
  }

  render() {
    let { align } = this.props
    return (
      <div
        className="card-time-picker"
        style={{ marginBottom: 12, textAlignLast: align ? align : "center" }}
      >
        <TimePicker
          placeholder={"hh : mm"}
          value={this.state.timeState ? this.state.timeState : null}
          onChange={this.onTimeChange.bind(this)}
          showSecond={false}
          disabled={this.props.disabled}
          style={{ width: 100 }}
          allowEmpty={false}
        />
      </div>
    );
  }
}

export default Pages;